module.exports = __webpack_public_path__ + "Flama-LightItalic.woff?414bf6f67572e5119f376e9a6cf54fd1";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-LightItalic.woff
// module id = 927
// module chunks = 0